// CacheKey 76d834ac6c3158efabf1cb9a1cc7b3e6
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  "en-ASCENT": {
    filters: {
      encounter: {
        label: "Visit",
        title: "Filter by visit id"
      }
    }
  }
}

